import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@shared/services';
import { LoginService } from '@modules/login/api/login/login.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'login-page',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  @ViewChild('loginForm') loginForm: HTMLFormElement;
  @ViewChild('forgotForm') forgotForm: HTMLFormElement;

  ngForm: FormGroup;
  loginUserName;
  userName;
  password;
  email;
  tempEmail: string;
  returnUrl: string;

  navigateForgotForm: boolean = false;

  // Forgot Password
  resetSuccess: boolean = false;
  isLoginProcess: boolean = false;
  isResetSent: boolean = false;
  isLoginError: boolean = false;
  isResendLink: boolean = false;
  isEmailAddressInvalid: boolean = false;
  fromPreOrder = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _auth: AuthService,
    private _login: LoginService,
    private title: Title
  ) {}

  ngOnInit() {
    this.title.setTitle(`Partbnb - Login`);
    this.returnUrl =
      this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
  }

  onSubmit(formStatus) {
    // stop here if form is invalid
    if (formStatus || this.isLoginProcess) {
      return;
    }
    this.isLoginProcess = true;
    this.isLoginError = false;

    this._auth
      .login(this.userName.trim(), this.password, this.returnUrl)
      .subscribe(
        res => {
          if (res) {
            this.isLoginProcess = false;
          }
        },
        () => {
          this.isLoginProcess = false;
          this.isLoginError = true;
          this.loginForm.form.controls['password'].setErrors({
            incorrect: true
          });
          this.password = null;
        }
      );
  }

  emailChange(evt) {
    if (this.isLoginError) {
      this.isLoginError = false;
    }
  }

  resetPassword(isResend = false) {
    if (isResend) {
      this.isResendLink = true;
    }
    this.isResetSent = true;
    const email = isResend ? this.tempEmail : this.email;
    this._login.checkAccount(email.trim()).subscribe(res => {
      if (res && res.code === 200) {
        this.tempEmail = email;
        this.email = '';
        this.resetSuccess = true;
        this.isResendLink = false;
      } else {
        this.isResetSent = false;
        this.forgotForm.form.controls['email'].setErrors({
          incorrect: true,
          invalid: true
        });
      }
    });
  }

  resendLink() {
    setTimeout(() => {
      this.isResendLink = false;
    }, 2000);
  }

  navigateForms(reset = false) {
    this.navigateForgotForm = !this.navigateForgotForm;
    if (reset) {
      this.isResetSent = false;
      this.resetSuccess = false;
    }
  }

  checkEmail(status) {
    if (status.invalid) {
      this.isEmailAddressInvalid = true;
      return;
    }
  }
}
